import { computed, getCurrentInstance } from '@vue/composition-api';
import { isOverseasVersion } from 'common-module/src/util';
import { useVuex } from 'common-module/src/util/useVuex';

export const useRouteState = () => {
  const instance = getCurrentInstance();
  const isNotFound = computed(() => instance?.proxy.$route.name === '404');
  const isSettingPage = computed(() => instance?.proxy.$route.path.startsWith('/setting/'));
  const isCreateProjectPage = computed(() => instance?.proxy.$route.path.startsWith('/project/create'));
  const isCreateProjectListOverseas = computed(() => instance?.proxy.$route.path.startsWith('/project/list') && isOverseasVersion);
  const isRecorderViewPage = computed(() => instance?.proxy.$route.path.startsWith('/work/view-recorder'));
  const isSharePage = computed(() => instance?.proxy.$route.meta?.share === true || instance?.proxy.$route.meta?.innerShare);
  const vuex = useVuex();
  const isSprintFeatures = computed(() => vuex.getters['features/isCurrentProjectSwitch']('module_sprint_switch'));
  const sprintList = computed(() => vuex.getters['sprint/sprintList']);
  const isEmptyKanbanOverseas = computed(() =>instance?.proxy.$route.path.startsWith('/kanban/list') && isOverseasVersion && sprintList.value.length === 0 && isSprintFeatures.value);

  return {
    isNotFound,
    isSettingPage,
    isCreateProjectPage,
    isCreateProjectListOverseas,
    isRecorderViewPage,
    isSharePage,
    isEmptyKanbanOverseas
  };
};
